import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFilesArray, IMessages, IStatusHistoryArray, ITaskInfo, ITaskState, TError } from './types/Task-interface';
import { fetcEditTask, fetchFileDownload, fetchSendMessage, fetchTaskCase, fetchTaskFiles, fetchTaskMessages, fetchTaskStatusHistory } from './actions/fetch-task-case';

const initialState: ITaskState = {
    TaskInfo: {
        Date: "",
        Number: "",
        AuthorsComment: "",
        ResponsiblesComment: "",
        AuthorsExpectedCompletionDate: "",
        StatusName: "",
        AgreementResultName: "",
        ThemeName: "",
        isLoadingTaskInfo: false,
        errorTaskInfo: [],
    },
    StatusHistory: {
        StatusHistory: [],
        isLoadingHistory: false,
        errorHistory: [],
    },
    Files: {
        Files: [],
        isLoadingFiles: false,
        errorFiles: [],
    },
    TaskMessages: {
        Messages: [],
        isLoadingTaskMessages: false,
        errorTaskMessages: [],
    },
    CreateMessage: {
        ID: '',
        Number: '',
        isLoadingCreateMessage: false,
        errorCreateMessage: [],
    },
    ApproveTask: {
        ID: '',
        Number: '',
        isLoadingApproveTask: false,
        errorApproveTask: [],
    },
    TaskID: "",
    isDownload: false,
    errorDownload: [],
    FileData: "",
    FileName: "",
    activeRequestsCount: 0,
};

export const TaskNew = createSlice({
    name: 'TaskNew',
    initialState,
    reducers: {
        resetTaskData: (state) => {
            state.TaskInfo = initialState.TaskInfo;
            state.StatusHistory = initialState.StatusHistory;
            state.Files = initialState.Files;
            state.TaskMessages = initialState.TaskMessages;
            state.CreateMessage = initialState.CreateMessage;
            state.TaskID = initialState.TaskID;
            state.isDownload = initialState.isDownload;
            state.errorDownload = initialState.errorDownload;
            state.FileData = initialState.FileData;
            state.FileName = initialState.FileName;
            state.ApproveTask = initialState.ApproveTask;
            state.activeRequestsCount = initialState.activeRequestsCount;
        },
        resetFileData: (state) => {
            state.TaskInfo = state.TaskInfo;
            state.StatusHistory = state.StatusHistory;
            state.Files = state.Files;
            state.TaskMessages = state.TaskMessages;
            state.TaskID = state.TaskID;
            state.isDownload = false;
            state.errorDownload = [];
            state.FileData = "";
            state.FileName = "";
        },
        resetCreateMessage: (state) => {
            state.CreateMessage = initialState.CreateMessage;
        },
        resetApproveTask: (state) => {
            state.ApproveTask = initialState.ApproveTask;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchTaskCase.pending, (state) => {
                state.activeRequestsCount += 1;
                state.TaskInfo.isLoadingTaskInfo = true;
            })
            .addCase(fetchTaskCase.fulfilled, (state, action: PayloadAction<{ task: ITaskInfo, TaskID: string }>) => {
                state.activeRequestsCount -= 1;
                state.TaskInfo = {
                    ...action.payload.task,
                    isLoadingTaskInfo: false,
                    errorTaskInfo: [],
                };
            })
            .addCase(fetchTaskCase.rejected, (state, action) => {
                state.activeRequestsCount -= 1;
                state.TaskInfo = {
                    ...initialState.TaskInfo,
                    isLoadingTaskInfo: false,
                    errorTaskInfo: action.payload as TError,
                };
            })

            .addCase(fetchTaskFiles.pending, (state) => {
                state.activeRequestsCount += 1;
                state.Files.isLoadingFiles = true;
            })
            .addCase(fetchTaskFiles.fulfilled, (state, action: PayloadAction<{ files: IFilesArray[], TaskID: string }>) => {
                state.activeRequestsCount -= 1;
                state.Files = {
                    Files: action.payload.files,
                    isLoadingFiles: false,
                    errorFiles: [],
                };
            })
            .addCase(fetchTaskFiles.rejected, (state, action) => {
                state.activeRequestsCount -= 1;
                state.Files = {
                    Files: [],
                    isLoadingFiles: false,
                    errorFiles: action.payload as TError,
                };
            })

            .addCase(fetchTaskStatusHistory.pending, (state) => {
                state.activeRequestsCount += 1;
                state.StatusHistory.isLoadingHistory = true;
            })
            .addCase(fetchTaskStatusHistory.fulfilled, (state, action: PayloadAction<{ statusHistory: IStatusHistoryArray[], TaskID: string }>) => {
                state.activeRequestsCount -= 1;
                state.StatusHistory = {
                    StatusHistory: action.payload.statusHistory,
                    isLoadingHistory: false,
                    errorHistory: [],
                };
            })
            .addCase(fetchTaskStatusHistory.rejected, (state, action) => {
                state.activeRequestsCount -= 1;
                state.StatusHistory = {
                    StatusHistory: [],
                    isLoadingHistory: false,
                    errorHistory: action.payload as TError,
                };
            })

            .addCase(fetchTaskMessages.pending, (state) => {
                state.activeRequestsCount += 1;
                state.TaskMessages.isLoadingTaskMessages = true;
            })
            .addCase(fetchTaskMessages.fulfilled, (state, action: PayloadAction<{ messages: IMessages[], TaskID: string }>) => {
                state.activeRequestsCount -= 1;
                state.TaskMessages = {
                    Messages: action.payload.messages,
                    isLoadingTaskMessages: false,
                    errorTaskMessages: [],
                };
            })
            .addCase(fetchTaskMessages.rejected, (state, action) => {
                state.activeRequestsCount -= 1;
                state.TaskMessages = {
                    Messages: [],
                    isLoadingTaskMessages: false,
                    errorTaskMessages: action.payload as TError,
                };
            })

            .addCase(fetchSendMessage.pending, (state) => {
                state.CreateMessage.isLoadingCreateMessage = true;
            })
            .addCase(fetchSendMessage.fulfilled, (state, action: PayloadAction<{ number: string; id: string; }>) => {
                state.CreateMessage = {
                    ID: action.payload.id,
                    Number: action.payload.number,
                    isLoadingCreateMessage: false,
                    errorCreateMessage: [],
                };
            })
            .addCase(fetchSendMessage.rejected, (state, action) => {
                state.CreateMessage = {
                    ...initialState.CreateMessage,
                    isLoadingCreateMessage: false,
                    errorCreateMessage: action.payload as TError,
                };
            })

            .addCase(fetchFileDownload.pending, (state) => {
                state.isDownload = true;
            })
            .addCase(fetchFileDownload.fulfilled, (state, action: PayloadAction<{ FileData: string, FileName: string }>) => {
                state.isDownload = false;
                state.errorDownload = [];
                state.FileData = action.payload.FileData;
                state.FileName = action.payload.FileName;
            })
            .addCase(fetchFileDownload.rejected, (state, action) => {
                state.isDownload = false;
                state.errorDownload = action.payload as string[];
                state.FileData = "";
                state.FileName = "";
            })
            .addCase(fetcEditTask.pending, (state) => {
                state.ApproveTask.isLoadingApproveTask = true;
            })
            .addCase(fetcEditTask.fulfilled, (state, action: PayloadAction<{ taskID: string, taskNumber: string }>) => {
                state.ApproveTask.isLoadingApproveTask = false;
                state.ApproveTask.errorApproveTask = [];
                state.ApproveTask.ID = action.payload.taskID;
                state.ApproveTask.Number = action.payload.taskNumber;
            })
            .addCase(fetcEditTask.rejected, (state, action) => {
                state.ApproveTask.isLoadingApproveTask = false;
                state.ApproveTask.errorApproveTask = action.payload as string[];
                state.ApproveTask.ID = "";
                state.ApproveTask.Number = "";
            });
    },
});

export const { resetTaskData, resetFileData, resetCreateMessage, resetApproveTask } = TaskNew.actions;
export default TaskNew.reducer;